/**
 * Canonical platform marketing stats — single source of truth for SEO copy.
 * Update values here only; use helpers or imports elsewhere.
 */
export const PLATFORM_STATS = {
    transporters: {
        count: 1_000_000,
        lakhNumber: 10,
        lakhs: "10 Lakh+",
        lakhsLong: "10 Lakhs+",
        numeric: "10,00,000+",
        verifiedShort: "10 lakh+ verified transporters",
        verifiedLorryOwners: "10 Lakh+ verified lorry owners"
    },
    verifiedTrucks: {
        count: 800_000,
        lakhNumber: 8,
        lakhs: "8 Lakh+",
        lakhsLong: "8 lakh+",
        lakhsLongPlural: "8 lakhs+"
    },
    users: {
        lakhs: "10 Lakh+"
    },
    dailyActiveLoads: {
        count: 20_000,
        label: "20,000+"
    },
    liveLoadsAndLorries: {
        count: 10_000,
        label: "10,000+"
    },
    dailyLoads: {
        count: 1_000,
        label: "1000+"
    },
    cities: {
        count: 850,
        label: "850+"
    },
    tripsCompleted: {
        count: 100_000,
        label: "1,00,000+"
    },
    bookings: {
        lakhs: "1 Lakh+"
    },
    appDownloads: {
        count: 1_000_000,
        millions: "1 Million+",
        lakhsLong: "10 Lakhs+"
    },
    locations: {
        count: 15_000,
        label: "15,000+"
    }
} as const;

/** i18n interpolation values — pass as the second arg to `t()` for locale strings using {{placeholders}}. */
export function getPlatformStatI18nLabels() {
    return {
        transportersLakhs: PLATFORM_STATS.transporters.lakhs,
        transportersLakhsLong: PLATFORM_STATS.transporters.lakhsLong,
        liveLoadsAndLorries: PLATFORM_STATS.liveLoadsAndLorries.label,
        dailyActiveLoads: PLATFORM_STATS.dailyActiveLoads.label,
        verifiedTrucksLakhs: PLATFORM_STATS.verifiedTrucks.lakhs,
        verifiedTrucksLakhsLong: PLATFORM_STATS.verifiedTrucks.lakhsLong,
        locations: PLATFORM_STATS.locations.label
    };
}
